import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from '../../../components/Header';
import ReactPlayer from "react-player";
import SocialMedia from '../../../components/SocialMedia';
import GlassCard from '../../../components/GlassCard';

import './styles.css';

export default class LabNinjasNormalSize extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDecorations: false,
      termsStatus: 'unknown'
    };
  }

  componentDidMount() {
    // Small delay ensures CSS transitions apply reliably after initial paint
    this._fadeTimer = setTimeout(() => {
      this.setState({ showDecorations: true });
    }, 50);
    this.updateTermsStatus();
    window.addEventListener('termsStatusChange', this.updateTermsStatus);
  }

  componentWillUnmount() {
    if (this._fadeTimer) clearTimeout(this._fadeTimer);
    window.removeEventListener('termsStatusChange', this.updateTermsStatus);
  }

  updateTermsStatus = () => {
    try {
      const storedValue = localStorage.getItem('termsStatus');
      const legacyValue = storedValue === null ? localStorage.getItem('termsAccepted') : null;
      const resolvedValue = storedValue ?? legacyValue;
      if (resolvedValue === 'accepted' || resolvedValue === 'true') {
        this.setState({ termsStatus: 'accepted' });
      } else if (resolvedValue === 'rejected') {
        this.setState({ termsStatus: 'rejected' });
      } else {
        this.setState({ termsStatus: 'unknown' });
      }
    } catch (error) {
      this.setState({ termsStatus: 'unknown' });
    }
  };

  render() {
    const { showDecorations, termsStatus } = this.state;
    const termsRejected = termsStatus === 'rejected';

    return (
      <Container fluid className={`fill-height page-root ${showDecorations ? 'show-decor' : ''}`}>
        <Header />

        <Row className="fill-height">
          <Col xs={3} md={3} className="panel left-panel">
            <Row className="align-content-between fill-height">
              <Row className="justify-content-md-center">
                <GlassCard className="disclaimer">
                  <h4 className='sr-only'>Lab Ninjas - Path to Revenge</h4>
                  <img
                    alt="Lab Ninjas Logo"
                    src="/lab_ninjas_logo.png"
                    className="game-logo"
                  />
                  <br /><br />
                  Lead an elite squad of ninjas on a quest for vengeance against their oppressors. Their village has been burned to the ground, their people scattered, and their honor tarnished. But they won’t surrender, <b>they fight back.</b>
                  <br /><br />
                  Now, they need <b>YOU</b> to guide them on their path to justice. Train, strategize, and battle against relentless enemies in a thrilling ninja survival adventure!
                  <br />
                </GlassCard>
              </Row>
            </Row>
            <SocialMedia />

            <div className="left-panel-art-anchor-1">
              <img
                src="/yellow_flare_website.png"
                alt=""
                aria-hidden="true"
                className="left-panel-bottom-image-1 decorative-image-static-1"
              />
            </div>

            <div className="left-panel-art-anchor-2">
              <img
                src="/takashi_website.png"
                alt=""
                aria-hidden="true"
                className="left-panel-bottom-image-2 decorative-image-static-2"
              />
            </div>
          </Col>

          <Col md={9} className="panel right-panel fill-height fill-width">
            <div className="game-container">
              <GlassCard className="game-container-inner">
                <div className="decorative-image-static youtube-player-wrapper">
                  {termsRejected ? (
                    <div className="terms-blocked">Accept terms to view this video.</div>
                  ) : (
                    <ReactPlayer
                      src="https://youtu.be/IHy6SX2st8g"
                      style={{ width: '80%', height: 'auto', aspectRatio: '16/9' }}
                      controls
                    />
                  )}
                </div>
                <br />
                <b>Available now</b>

                <div className="store-badge-wrap">
                  <img
                    className="google-play-hover-image decorative-image"
                    src="/kunoichi_website.png"
                    alt="Lab Ninjas preview"
                  />

                  <a
                    className="google-play-link"
                    href="https://play.google.com/store/apps/details?id=com.forfunlab.labninjaspathtorevenge"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="Get it on Google Play"
                      src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
                      className="google-play-button"
                      style={{ height: '85px' }}
                    />
                  </a>
                </div>
              </GlassCard>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}
